var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const AngleLeft = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-angle_left ${className}`} {...other}>
      <g>
        <path d="M9.978 13.179L4.801 8.002l5.177-5.177a.5.5 0 01.707 0l.354.354a.5.5 0 010 .707L6.923 8.002l4.116 4.116a.5.5 0 010 .707l-.354.354a.5.5 0 01-.707 0z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default AngleLeft;
